import posthog from 'posthog-js'

export function usePostHog() {
  posthog.init('phc_VxetX4Q4tIvHHrM5HageCLa3Dh2UgRS5SbbFwh1mT2K', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false, // We'll handle this via router
    capture_pageleave: true,
    autocapture: true,
  })

  return { posthog }
}
